export default "* Fisk\n* Kunstværk\n* Etik";